import React from 'react';
import { cn } from '@/lib/cn';
import { Icon } from '@iconify/react/dist/iconify.js';

interface InsightCardProps {
  label: string;
  value: number;
  percentage: number;
  isActive: boolean;
  isLoading: boolean;
  onClick: () => void;
}

const InsightCard: React.FC<InsightCardProps> = ({
  label,
  value,
  percentage,
  isLoading,
  isActive,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className={cn(
        'relative cursor-pointer rounded-2xl bg-white px-6 py-4 ring-1 ring-slate-200 transition-all duration-300 hover:bg-gray-50',
        isActive && 'transform bg-[#F4F4F4] ring-1 ring-[#52525B]',
      )}
    >
      <div className='flex items-center justify-between'>
        <div>
          <p className='mb-2 text-xs font-medium text-slate-600'>{label}</p>
          <p className='text-2xl font-bold text-slate-800 sm:text-3xl'>
            {value}
          </p>
        </div>
      </div>

      <div className='sm:absolute sm:right-6 sm:top-1/2 sm:-translate-y-1/2'>
        <p
          className={cn(
            'sm:text-md flex items-center gap-1 text-sm font-medium',
            isLoading && 'animate-[pulse_3s_ease-in-out_infinite]',
            percentage > 0 ? 'text-green-600' : 'text-red-600',
          )}
        >
          <Icon
            icon={percentage > 0 ? 'mdi:arrow-up' : 'mdi:arrow-down'}
            className='h-5 w-5'
          />
          {Math.abs(percentage)}%
        </p>
      </div>
    </div>
  );
};

export default InsightCard;
